'use client';

import { Suspense } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { AuthOtpForm } from '@/components/auth/otp-form';
import { useTranslations } from '@/components/language-provider';

export default function SignupPage() {
  return (
    <Suspense fallback={null}>
      <SignupContent />
    </Suspense>
  );
}

function SignupContent() {
  const { messages } = useTranslations();
  const content = messages.auth.otp;
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo') ?? undefined;
  const loginHref = returnTo ? `/auth/login?returnTo=${encodeURIComponent(returnTo)}` : '/auth/login';

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 py-16">
      <AuthOtpForm mode="signup" returnTo={returnTo} />
      <p className="mt-8 text-sm text-muted-foreground">
        {content.signupHasAccount}{' '}
        <Link className="text-primary underline hover:text-primary/80" href={loginHref}>
          {content.signupHasAccountCta}
        </Link>
      </p>
    </div>
  );
}
